const Layout = Object.freeze({
  FullWidth : "FULL_WIDTH",
  Central    : "CENTRAL"
});

export default Layout;